import React from 'react';

import FlexLink from '@components/FlexLink';
import IconPlus from '@components/Images/Rebranding/IconPlus';
import { useEventTracking } from '@hooks';
import { new_forum_post_path } from '@routes';
import { ClickTarget, click } from '@tracking';

export enum ForumTypeRequest {
  Post = 'post',
  Poll = 'poll',
}

export type NewForumPostButtonProps = {
  forumTypeRequest: ForumTypeRequest;
};

export default function NewForumPostButton({ forumTypeRequest }: NewForumPostButtonProps) {
  const { trackEvent } = useEventTracking();

  const handleWritePostClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.WritePost }));
  };

  return (
    <FlexLink
      href={new_forum_post_path({ type: forumTypeRequest })}
      className="flex w-full items-center justify-center gap-8 border border-solid border-primary-magenta bg-primary-magenta px-16 py-8 font-suisse-intl text-button-sm text-white transition-colors hover:border-primary-pink hover:bg-primary-pink hover:text-primary-magenta active:opacity-75"
      onClickCapture={handleWritePostClick}
    >
      <IconPlus className="h-16 w-16 shrink-0 stroke-2" />
      {forumTypeRequest === ForumTypeRequest.Post ? 'Post' : 'Poll'}
    </FlexLink>
  );
}
